import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface QueryParams {
  key_word: string
  start_time: Date
  end_time: Date
  sort: string
  asc: boolean
  page: number
  limit: number
}

export interface SoftwareModifyData {
  device_id: string // 终端设备id
  change_time: number // 变更时间
  computer_name: string
  user_mark: string
  group_name: string
  soft_name: string // 软件名
  action: number // 事件类型,1-卸载，2-升级，3-安装
  soft_id: number // 软件id
}

@Injectable()
export class SoftwareModifyLogService {
  constructor (private http: Http) {
  }

  @ParamsClean()

  @InvokeThrottle()
  getSoftwareModifyList (params: Partial<QueryParams>) {
    return this.http.post<{
      total: number
      list: SoftwareModifyData[]
    }>('/logmanage/software-change/list', params)
  }
  download (type: 0|1, options: Partial<QueryParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/logmanage/software-change/list/export', params, moduleName)
  }
}
